import React, { createContext, useContext, useState, useEffect } from "react";
import Axios from "axios";

const SupplierContext = createContext();

export const SupplierProvider = ({ children }) => {
  const [suppliers, setSuppliers] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  // 🔄 جلب كل الموردين
  const fetchSuppliers = async () => {
    try {
      setIsFetching(true);
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/supplier/getSuppliers.php`
      );
      if (res.data.status === "success") {
        setSuppliers(res.data.suppliers || []);
      } else {
        console.error("⚠️ فشل في جلب الموردين:", res.data.message);
      }
    } catch (err) {
      console.error("❌ خطأ أثناء جلب الموردين:", err);
    } finally {
      setIsFetching(false);
    }
  };

  // ➕ إضافة مورد جديد
  const addSupplier = async (supplierData) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/supplier/newSupplier.php`,
        supplierData
      );
      if (res.data.status === "success") {
        setSuppliers((prev) => [...prev, res.data.supplier]);
        return { success: true, message: res.data.message };
      } else {
        return { success: false, message: res.data.message };
      }
    } catch (err) {
      console.error("❌ خطأ أثناء إضافة المورد:", err);
      return {
        success: false,
        message: err.response?.data?.message || "حدث خطأ أثناء الإضافة",
      };
    }
  };

  // ✏️ تحديث مورد
  const updateSupplier = async (supplierData) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/supplier/updateSupplier.php?id=${supplierData.id}`,
        supplierData
      );
      if (res.data.status === "success") {
        setSuppliers((prev) =>
          prev.map((supplier) =>
            supplier.id === supplierData.id ? res.data.supplier : supplier
          )
        );
        return { success: true, message: res.data.message };
      } else {
        return { success: false, message: res.data.message };
      }
    } catch (err) {
      console.error("❌ خطأ أثناء تحديث المورد:", err);
      return {
        success: false,
        message: err.response?.data?.message || "حدث خطأ أثناء التحديث",
      };
    }
  };

  // 📋 جلب بيانات مورد واحد مع فواتيره
  const getSupplierProfile = async (id) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/supplier/getSupplierProfile.php?id=${id}`
      );
      if (res.data.status === "success") {
        return res.data;
      } else {
        throw new Error(res.data.message);
      }
    } catch (err) {
      console.error("❌ خطأ أثناء جلب بيانات المورد:", err);
      throw err;
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  return (
    <SupplierContext.Provider
      value={{
        suppliers,
        setSuppliers,
        isFetching,
        fetchSuppliers,
        addSupplier,
        updateSupplier,
        getSupplierProfile,
      }}
    >
      {children}
    </SupplierContext.Provider>
  );
};

// ✅ هوك مخصص للاستخدام
export const useSupplierContext = () => useContext(SupplierContext);
